export class LanguageService {
    constructor() {
        this.lang = '';
    }
    getLanguage() {
        return this.lang;
    }
    setLanguage(lang) {
        this.lang = lang;
    }
    translate(mlstring, lang) {
        const value = mlstring.value;
        if (typeof value === 'string') {
            return value;
        }
        const langToUse = lang !== null && lang !== void 0 ? lang : this.lang;
        if (langToUse in value) {
            return value[langToUse];
        }
        else {
            console.error(`Missing translation of ${JSON.stringify(value)} for ${langToUse} language`);
            return '-';
        }
    }
    translateOptional(mlString, defaultValue = '', lang) {
        return mlString == null ? defaultValue : this.translate(mlString, lang);
    }
}
//# sourceMappingURL=LanguageService.js.map